import { makeStyles } from 'makeStyles';
import { DISABLED_AND_BORDERS } from 'theme/colors';

export const useStyles = makeStyles()((theme) => ({
  container: {
    minHeight: '100vh',
  },
  logo: {
    width: 180,
    margin: `${theme.spacing(6)} auto ${theme.spacing(6)} auto`,
  },
  errorMessage: {
    textAlign: 'center',
  },
  errorImage: {
    marginBottom: theme.spacing(3.5),
    '& img': {
      display: 'block',
      objectFit: 'contain',
      width: '100%',
      minHeight: 296,
    },
  },
  text: {
    textAlign: 'center',
    '&:not(:first-of-type)': {
      marginTop: theme.spacing(1),
    },
  },
  actions: {
    width: 'fit-content',
    marginTop: theme.spacing(5),
  },
  divider: {
    margin: `0 ${theme.spacing(3)}`,
  },
  errorBlock: {
    userSelect: 'all',
    fontWeight: 'bold',
    border: `1px solid ${DISABLED_AND_BORDERS}`,
    borderRadius: 4,
    width: 200,
    padding: theme.spacing(3),
    margin: `${theme.spacing(2.2)} auto 0 auto`,
    fontSize: 15,
  },
}));
